import React, { Component } from "react"
import Modal from "react-modal"
import CustomerInvoicesCreateModalUI from "./CustomerInvoicesCreateModalUI"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"

class CustomerInvoicesCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,

      submitted: false,

      invoiceName: '',
      invoiceNameError: null,
      dueDate: '',
      dueDateError: null,
      customerNotes: '',
      customerNotesError: null,
      customerId: '',
      customerIdError: null,
      //
      invoiceNumber: '',
      invoiceNumberError: null,
      eWayBill: '',
      eWayBillError: null,
      vehicleNumber: '',
      vehicleNumberError: null,
      dateOfSupply: '',
      dateOfSupplyError: null,
      orderDate: '',
      orderDateError: null,
      orderNumber: '',
      orderNumberError: null,
      productDescription: '',
      productDescriptionError: null,
    }
  }

  render() {
    return (
      <CustomerInvoicesCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}

        createMode={this.props.createMode}
        submitted={this.state.submitted}

        onSubmit={this.onSubmit}
        onCancelCreate={this.onCancelCreate}

        invoiceName={this.state.invoiceName}
        onInvoiceNameChange={(event) => { this.setState({ invoiceName: event.target.value }) }}
        invoiceNameError={this.state.invoiceNameError}
        setInvoiceNameError={(error) => { this.setState({ invoiceNameError: error }) }}

        // dueDate={this.state.dueDate}
        // onDueDateChange={(selectedDateISO) => {
        //     this.setState({dueDate: selectedDateISO})
        //   }}
        // dueDateError={this.state.dueDateError}
        // setDueDateError={(error) => { this.setState({ dueDateError: error }) }}

        customerNotes={this.state.customerNotes}
        onCustomerNotesChange={(event) => { this.setState({ customerNotes: event.target.value }) }}
        customerNotesError={this.state.customerNotesError}
        setCustomerNotesError={(error) => { this.setState({ customerNotesError: error }) }}

        customerId={this.state.customerId}
        onCustomerIdChange={(event) => { this.setState({ customerId: event.target.value }) }}
        customerIdError={this.state.customerIdError}
        setCustomerIdError={(error) => { this.setState({ customerIdError: error }) }}
        customerList={this.props.customerList}
        //
        invoiceNumber={this.state.invoiceNumber}
        onInvoiceNumberChange={(event) => { this.setState({ invoiceNumber: event.target.value }) }}
        invoiceNumberError={this.state.invoiceNumberError}
        setInvoiceNumberError={(error) => { this.setState({ invoiceNumberError: error }) }}
        //
        eWayBill={this.state.eWayBill}
        onEWayBillChange={(event) => { this.setState({ eWayBill: event.target.value }) }}
        eWayBillError={this.state.eWayBillError}
        setEWayBillError={(error) => { this.setState({ eWayBillError: error }) }}
        //
        vehicleNumber={this.state.vehicleNumber}
        onVehicleNumberChange={(event) => { this.setState({ vehicleNumber: event.target.value }) }}
        vehicleNumberError={this.state.vehicleNumberError}
        setVehicleNumberError={(error) => { this.setState({ vehicleNumberError: error }) }}
        //
        dateOfSupply={this.state.dateOfSupply}
        onDateOfSupplyChange={(selectedDateISO) => { this.setState({ dateOfSupply: selectedDateISO }) }}
        dateOfSupplyError={this.state.dateOfSupplyError}
        setDateOfSupplyError={(error) => { this.setState({ dateOfSupplyError: error }) }}
        //
        orderDate={this.state.orderDate}
        onOrderDateChange={(selectedDateISO) => { this.setState({ orderDate: selectedDateISO }) }}
        orderDateError={this.state.orderDateError}
        setOrderDateError={(error) => { this.setState({ orderDateError: error }) }}
        //
        orderNumber={this.state.orderNumber}
        onOrderNumberChange={(event) => { this.setState({ orderNumber: event.target.value }) }}
        orderNumberError={this.state.orderNumberError}
        setOrderNumberError={(error) => { this.setState({ orderNumberError: error }) }}
        //
        productDescription={this.state.productDescription}
        onProductDescriptionChange={(event) => { this.setState({ productDescription: event.target.value }) }}
        productDescriptionError={this.state.productDescriptionError}
        setProductDescriptionError={(error) => { this.setState({ productDescriptionError: error }) }}
      />
    )
  }

  onCancelCreate = () => {
    this.setState({
      submitted: false,
      errorList: null
    })
    this.props.onCancelCreate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/customers/${this.state.customerId}/customerInvoices`,
      this.onSubmitCallback, {
      invoiceName: this.state.invoiceName,
      dueDate: this.state.dueDate,
      customerNotes: this.state.customerNotes,
      customerId: this.state.customerId,
      invoiceNumber: this.state.invoiceNumber,
      eWayBill: this.state.eWayBill,
      vehicleNumber: this.state.vehicleNumber,
      dateOfSupply: this.state.dateOfSupply,
      orderDate: this.state.orderDate,
      orderNumber: this.state.orderNumber,
      productDescription: this.state.productDescription,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default CustomerInvoicesCreateModalSF;